import { Flex, useBreakpointValue } from "@chakra-ui/react"
import useConfig from "src/hooks/useConfig"
import { PlansData } from "./PlansData"
import { StripeSubscriptionCard } from "./StripeSubscriptionCard"

export type StripePlan = {
  name: string
  description: string
  productId: string
  priceString: string
  renewalString?: string
}

type Props = {
  plansData: PlansData
  fetchPlansData: () => Promise<void>
}

export const StripeSubscriptionPlans = ({
  plansData,
  fetchPlansData
}: Props) => {
  const { stripeProductIds } = useConfig()
  const plans: StripePlan[] =
    stripeProductIds === "loading"
      ? []
      : [
          {
            name: "Light",
            description: "Up to 1 hour per day",
            productId: stripeProductIds.at(0),
            priceString: "£9.99",
            renewalString: "month"
          },
          {
            name: "Deep",
            description: "Up to 4 hours per day",
            productId: stripeProductIds.at(1),
            priceString: "£19.99",
            renewalString: "month"
          },
          {
            name: "Unlimited",
            description: "There for you 24/7",
            productId: stripeProductIds.at(2),
            priceString: "£59.99",
            renewalString: "month"
          }
        ]

  const flexDirection: any = useBreakpointValue({ base: "column", md: "row" })
  return (
    <Flex
      gap="10px"
      flexDirection={flexDirection}
      alignItems={"center"}
      justifyContent="center"
    >
      {plans.map((plan, index) => {
        let cardType
        const hasActivePlan = plansData?.entitled
        const hasUnsubscribed = plansData?.unsubscribeDetectedAt != null
        if (hasActivePlan && !hasUnsubscribed) {
          cardType =
            plan.productId == plansData?.productIdentifier ? "cancel" : "update"
        } else {
          cardType =
            plan.productId == plansData?.productIdentifier
              ? "renew"
              : hasActivePlan
              ? "update"
              : "purchase"
        }
        return (
          <StripeSubscriptionCard
            key={index}
            fetchPlansData={fetchPlansData}
            plansData={plansData}
            stripePlan={plan}
            cardType={cardType}
          />
        )
      })}
    </Flex>
  )
}
